module.exports = __webpack_public_path__ + "413b39885e37923598ef9801ef610ea9.png";